import Alert from 'react-bootstrap/Alert'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { useNavigate } from 'react-router-dom'
import { changePassword } from '../../../types'
import { formSubmit } from '../api/actionApiCall'
import { useAuth } from '../auth/AuthContext'
import { SubmitButton, TextField, useFormState } from '../components/form'

export function ChangePasswordPage() {
    const { user, setUser } = useAuth()
    const navigate = useNavigate()
    const forced = user?.mustChangePassword ?? false

    const form = useFormState({
        initialValues: { currentPassword: '', newPassword: '', newPasswordAgain: '' },
        onSubmit: async (values) => {
            if (values.newPassword !== values.newPasswordAgain) {
                return { fieldErrors: { newPasswordAgain: 'Hesla se neshodují.' } }
            }

            const { data, fieldErrors } = await formSubmit(
                () => changePassword({ body: { currentPassword: values.currentPassword, newPassword: values.newPassword } }),
                { successMessage: 'Heslo bylo změněno.' },
            )

            if (!data) {
                return { fieldErrors }
            }

            setUser(data)
            navigate('/', { replace: true })
        },
    })

    return (
        <Row className="justify-content-center">
            <Col xs={12} sm={10} md={6} lg={5}>
                <Card className="mt-3">
                    <Card.Body>
                        <h1 className="h4 mb-3">Změna hesla</h1>

                        {forced && (
                            <Alert variant="warning" className="py-2">
                                Přihlásili jste se dočasným heslem od správce. Než budete pokračovat, zvolte si vlastní heslo.
                            </Alert>
                        )}

                        <form onSubmit={form.handleSubmit} noValidate>
                            <TextField
                                label="Stávající heslo"
                                type="password"
                                value={form.values.currentPassword}
                                onChange={(value) => form.setValue('currentPassword', value)}
                                error={form.fieldErrors.currentPassword}
                                autoComplete="current-password"
                                required
                            />
                            <TextField
                                label="Nové heslo"
                                type="password"
                                value={form.values.newPassword}
                                onChange={(value) => form.setValue('newPassword', value)}
                                error={form.fieldErrors.newPassword}
                                helpText="Alespoň 8 znaků."
                                autoComplete="new-password"
                                required
                            />
                            <TextField
                                label="Nové heslo znovu"
                                type="password"
                                value={form.values.newPasswordAgain}
                                onChange={(value) => form.setValue('newPasswordAgain', value)}
                                error={form.fieldErrors.newPasswordAgain}
                                autoComplete="new-password"
                                required
                            />
                            <div className="d-flex gap-2">
                                <SubmitButton submitting={form.submitting}>Změnit heslo</SubmitButton>
                            </div>
                        </form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}
